import React from 'react';

import {IconButton} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {useGetApi} from 'common/hooks/useGetApi';
import {ISecretData} from 'types/diplomat/authentication/SecretData';
import {LoaderInline} from 'components/Loader';

export const FetchPassButton = ({
   url,
   setValue,
   setVisible,
   toggleVisibility,
   obfuscated,
}: {
   url: string;
   obfuscated: boolean;
   setValue: (val: string, reset: boolean) => void;
   setVisible?: () => void;
   toggleVisibility?: () => void;
}) => {
   const {request, loading} = useGetApi<ISecretData>(url, {
      onSuccess(val) {
         setValue(val.secret, true);
         setVisible?.();
      },
   });

   return (
      <IconButton
         aria-label="edit"
         size={'small'}
         disabled={loading}
         onClick={() => (obfuscated ? request() : toggleVisibility?.())}
         edge="end"
      >
         {loading ? <LoaderInline /> : <VisibilityIcon />}
      </IconButton>
   );
};
